import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import AuthShell from '../components/AuthShell';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error('Passwords do not match');
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      const r = await api.post('/auth/reset-password', { token, password: form.password });
      login(r.data.token, r.data.user);
      toast.success('Password updated — you are signed in');
      nav('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Reset failed');
    }
    setLoading(false);
  }

  if (!token) {
    return (
      <AuthShell eyebrow="Link expired" title="This reset link is incomplete" subtitle="It may have been cut off or may no longer be valid.">
          <p className="auth-message">
            <Link to="/forgot-password">Request a new password reset link →</Link>
          </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell eyebrow="Secure your account" title="Choose a new password" subtitle="Use at least six characters and make it memorable only to you.">
        <form onSubmit={handleSubmit}>
          <div className="form-group auth-field">
            <label className="label">New password</label>
            <input className="input" type="password" required autoFocus
              value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder="••••••••" />
          </div>
          <div className="form-group auth-field">
            <label className="label">Confirm new password</label>
            <input className="input" type="password" required
              value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
              placeholder="••••••••" />
          </div>
          <button type="submit" className={'btn btn-primary btn-lg btn-block' + (loading ? ' is-loading' : '')} disabled={loading}>
            {loading ? 'Updating…' : 'Update password'}
          </button>
        </form>
        <p className="auth-switch">
          <Link to="/login">← Back to sign in</Link>
        </p>
    </AuthShell>
  );
}
